import { RegisterComponent } from '@feng3d/ecs';
import { HemisphereLight } from '../../thirdparty/three/imports';
import { Light3D } from './Light3D';

declare module '@feng3d/ecs'
{
    interface ComponentMap { HemisphereLight3D: HemisphereLight3D; }
}

/**
 * 包装`three`中`HemisphereLight`
 */
@RegisterComponent({ name: 'HemisphereLight3D' })
export class HemisphereLight3D extends Light3D
{
    _light: HemisphereLight = new HemisphereLight();

    get groundColor()
    {
        return this._light.groundColor;
    }
    set groundColor(v)
    {
        this._light.groundColor = v;
    }
}
